module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1241.129bd479.png";